import { useMemo } from 'react'
import isEmpty from 'lodash/isEmpty'
import isArray from 'lodash/isArray'
import { onMergeConfigAndDefault } from '@/components/QueryFilterWithConfig/untils'

export const getConfigAndFieldsFrom = (fields, config, defaultSetting) => {
    let newFields = []
    let targetConfig = {}
    if (isEmpty(config)) {
        newFields = fields?.map((item, index) => {
            targetConfig[item?.name] = {
                ...defaultSetting,
                show: item?.defaultShow !== undefined ? item.defaultShow : true,
                sort: 'sort' in item ? item.sort : index
            }
            return item
        })
    } else {
        // 生成一份用来跟用户已配置的数据合并的基础表单fields, 因为和那个默认的表单field有区别,所以需要这里重置
        const originalFields = fields
            ?.map(item => ({
                ...item,
                defaultShow: config?.[item?.name] ? config?.[item?.name]?.show : false,
                sort: item?.initSort
            }))
            .sort((a, b) => (a?.initSort || 0) - (b?.initSort || 0))
        const formatConfigArr = Object.keys(config)
            ?.map(name => ({
                name,
                sort: config[name]?.sort,
                defaultShow: config[name]?.show
            }))
            .sort((a, b) => (a?.sort || 0) - (b?.sort || 0))
            ?.map(item => ({
                name: item?.name,
                defaultShow: item?.defaultShow
            }))

        const { formatSortDefaultQueryConfigVersionDetail: mergeFields } = onMergeConfigAndDefault(
            formatConfigArr,
            originalFields
        )
        newFields = mergeFields?.map((item, index) => {
            targetConfig[item?.name] = {
                ...defaultSetting,
                show: item?.defaultShow,
                sort: 'sort' in item ? item.sort : index
            }
            return item
        })
    }

    return {
        newFields,
        targetConfig
    }
}

// 用于生成用户的配置config,当用户没有配置时(null),那么就从fields中抽取(defaultShow)
// 如果用户有配置时,
//     如果field中有,但是用户配置中没有,那么用field中的配置生成(initShow)
//     如果用户配置中有的话,那么用用户配置
/**
 *
 * @param {*} fields 组件外部传入的fields
 * @param {*} config 用户对筛选区的配置项,为null时表示用户没有配置
 * @param {*} initCheckStatus 表示默认是否被选中,这里是要处理当接口失败的情况
 * @returns
 */
export const useGenConfigFields = (fields, config, initCheckStatus) => {
    const defaultSetting = {
        show: initCheckStatus,
        enable: true
    }
    return useMemo(() => {
        const { targetConfig } = getConfigAndFieldsFrom(fields, config, defaultSetting)
        const target = fields
            ?.map(item => {
                const setting = targetConfig[item.name]
                const fieldName =
                    item.labelName ||
                    (isArray(item?.props?.placeholder) ? item?.props?.placeholder.join('/') : item?.props?.placeholder)
                return {
                    ...setting,
                    key: item.name,
                    fieldName
                }
            })
            .sort((a, b) => (a?.sort || 0) - (b?.sort || 0))

        return {
            fieldItems: target,
            config: targetConfig
        }
    }, [fields, config, initCheckStatus])
}
